/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { TOM_API } = process.env

export const apiTom = axios.create({
  baseURL: TOM_API,
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})

